import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'

import ListTechnology from './ListTechnology'

import EditTechnology from './EditTechnology'
import NewTechnology from './NewTechnology'

const SpecialistTechnologyRoutes = () => {

  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListTechnology /></PrivateRoute7>} />
        <Route path="edit-technology" element={<PrivateRoute7><EditTechnology /></PrivateRoute7>} />
        <Route path="new-technology" element={<PrivateRoute7><NewTechnology /></PrivateRoute7>} />
    </Routes>
  )
}

export default SpecialistTechnologyRoutes